import React from 'react';
import NormalizedWrapper from './Normalizer';

const SeoTextTop: React.SFC<{ rawHtml: string }> = ({ rawHtml }) => (
    <NormalizedWrapper data-testid="seo_text_top" dangerouslySetInnerHTML={{ __html: rawHtml }} />
);

export default SeoTextTop;
